import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureChatAccountSummary(props) {
    return <AccountSummaryPage />
}